import React from 'react';
import {Row, Col, Icon} from 'antd';
import classNames from 'classnames';
import { isEqual } from 'lodash';

class App extends React.Component {

  static defaultProps = {
    prefixCls: 'search-list',
    labelSpan: 2,
    valueSpan: 22,
  }

	constructor(props) { 
    super(props);
    this.state = {
      selectKey: this.props.selectKey || (this.props.radio ? '' : []),
      datas: this.props.datas || [],
      unroll: false,
      active: false,
    }
  }

  componentDidMount() {
    this.showButton();
    window.addEventListener('resize', this.showButton);
  }

  componentWillReceiveProps(nextProps) {
    const { selectKey, datas } = nextProps;
    this.state.selectKey !== selectKey && this.setState({selectKey});
    !isEqual(datas, this.state.datas) && this.setState({datas}, () => this.showButton())
    this.showButton();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.showButton);
  }

  showButton = () => {
    const dataRow = this.dataRow;
    const { unroll } = this.state;
    if(dataRow && dataRow.offsetHeight > 33) {
      !unroll && this.setState({unroll: true});
    } else {
      unroll && this.setState({unroll: false});
    }
  }
  
  onClick = (id) => {
    const { onSelect, radio } = this.props;
    const { selectKey } = this.state;
    let _selectKey = id;
    if(!radio) {
      _selectKey = [...selectKey];
      const index = selectKey.indexOf(id);
      (_selectKey.length === 0 || index === -1) ? _selectKey.push(id) : _selectKey.splice(index, 1);
    }
    this.setState({selectKey: _selectKey});
    typeof onSelect === 'function' && onSelect(_selectKey);
  }

  isSelect = (key) => {
    const { selectKey } = this.state;
    const { radio } = this.props;
    if(!radio) {
      return selectKey.some(item => item == key);
    }
    return selectKey == key;
  }

	render() {
    const { prefixCls, className, label, style, labelSpan, valueSpan } = this.props;
    const { unroll, active, datas } = this.state;
		let rowStyle = style || {};
    rowStyle.background = "#f4f4f4";
    if(datas.length === 0) return null;
    const dataClassName =  classNames({
      [`${prefixCls}-row-data-box`]: true,
      'not-unroll': !active,
    });
		return (
			<Row className={`${prefixCls}-row ${className}`}>
				<Col span={labelSpan} className={`${prefixCls}-row-label`}>
					{label}
				</Col>
				<Col span={valueSpan} className={`${prefixCls}-row-data`}>
          <div className={dataClassName}>
            <span ref={ref => this.dataRow = ref}>
              {
                datas.map(
                  data => {
                    const cls = classNames({
                      [`${prefixCls}-row-data-link`]: true,
                      'select': this.isSelect(data.id),
                    });
                    return <a key={data.id} className={cls} onClick={() => this.onClick(data.id)}>{ data.typeName }</a>
                  }
                )
              }
            </span>
          </div>
				</Col>
        {
          unroll && 
          <div className={`${prefixCls}-row-button`} onClick={() => this.setState({active: !active})}>
            {
              active ? <span>收起<Icon type="up" /></span> : <span>展开<Icon type="down" /></span>
            }
          </div>
        }
		  </Row>
		)
	}
};

export default App;


// WEBPACK FOOTER //
// ./src/components/util/SearchList.js